import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {
  IAuditTable,
  ISystemLogsBody,
  ISystemLogsTable,
  ISystemLogsUser,
} from '../interfaces/system-logs.interface';

@Injectable({
  providedIn: 'root',
})
export class SystemLogsService {
  private url = `${environment.API}api/AuditLog/`;

  constructor(private http: HttpClient) {}

  getAllAudit(body: ISystemLogsBody): Observable<IAuditTable[]> {
    return this.http.post<IAuditTable[]>(`${this.url}GetAllAudit`, body);
  }

  getGeneralAudit(body: ISystemLogsBody): Observable<ISystemLogsTable[]> {
    return this.http.post<ISystemLogsTable[]>(
      `${this.url}GetGeneralAudit`,
      body
    );
  }

  getCountOfItems(body: ISystemLogsBody): Observable<number> {
    return this.http.post<number>(`${this.url}GetNumberOfAllRecords`, body);
  }

  getEmployeeNames(date: string): Observable<ISystemLogsUser[]> {
    return this.http.post<ISystemLogsUser[]>(`${this.url}GetEmployeeNames`, {
      date,
    });
  }
}
